import axios from "axios";
import { DataGrid, Toolbar } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Editing,
  HeaderFilter,
  Lookup,
  Paging,
  Position,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { clinicalSiteStepType } from "../data";
import {
  addClinicalSiteSteps,
  removeClinicalSiteSteps,
  updateApvExpDate,
  updateApvNo,
  updateClinicalSiteSteps,
  updateSiteNo,
  updateStep,
} from "./Redux/IRB";
import { Item } from "devextreme-react/toolbar";

const IRBClinicalSiteFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function IRBClinicalSiteForm(props) {
  const {
    sales,
    // step, setStep
  } = props;

  const dispatch = useDispatch();

  const IRB = useSelector((state) => state.IRB);

  const IRBClinicalSiteGridRef = useRef(null);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["type", "name"],
        load: async () => {
          if (IRB.clinicalSiteSteps.length > 0) {
            return IRB.clinicalSiteSteps;
          } else {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/clinicalSite/${sales.contrNo}/${IRB.siteNo}`
            );

            result.data.map((clinicalSiteStep) => {
              dispatch(
                addClinicalSiteSteps({
                  clinicalSiteSteps: clinicalSiteStep,
                })
              );
            });
            // dispatch(
            //   addClinicalSiteSteps({
            //     clinicalSiteSteps: result.data,
            //   })
            // );

            // return result.data;
            return IRB.clinicalSiteSteps;
          }
        },
        insert: async (values) => {
          dispatch(
            addClinicalSiteSteps({
              clinicalSiteSteps: values,
            })
          );
        },
        update: async (key, values) => {
          dispatch(
            updateClinicalSiteSteps({
              preClinicalSiteSteps: key,
              clinicalSiteSteps: values,
            })
          );
        },
        remove: async (key) => {
          dispatch(
            removeClinicalSiteSteps({
              clinicalSiteSteps: key,
            })
          );
        },
      })
    );
  }, [IRB.clinicalSiteSteps]);

  const itemRender = ({ siteNo, yadmNm, INSPCT_MANAGER_NAME }) => {
    return (
      <div>
        {/* {siteNo}-{LAB_NAME}-{INSPCT_MANAGER_NAME} */}
        {siteNo}-{yadmNm}-{INSPCT_MANAGER_NAME}
      </div>
    );
  };

  const displayExpr = (item) => {
    if (item) {
      // return `${item.siteNo}-${item.LAB_NAME}-${item.INSPCT_MANAGER_NAME}`;
      return `${item.siteNo}-${item.yadmNm}-${item.INSPCT_MANAGER_NAME}`;
    } else {
      return null;
    }
  };

  const onSaveClick = () => {};

  const prevItemOptions = {
    text: "PREVIOUS",
    onClick: () => {
      // setStep(0);
      dispatch(
        updateStep({
          step: 0,
        })
      );
    },
  };

  const nextItemOptions = {
    text: "NEXT",
    onClick: () => {
      // setStep(2);
      dispatch(
        updateStep({
          step: 2,
        })
      );
    },
  };

  return (
    <IRBClinicalSiteFormWrapper>
      <div
        style={{
          margin: "3px auto",
          width: "75vw",
        }}
      >
        <span style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}>
          CLINICAL SITE STEPS
        </span>
        <DataGrid
          id="IRBClinicalSiteGrid"
          ref={IRBClinicalSiteGridRef}
          dataSource={dataSource}
          key={["type", "name"]}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode="widget"
          rowAlternationEnabled={true}
          showBorders={true}
          showRowLines={true}
          showColumnLines={true}
          width={"100%"}
          headerFilter={"100%"}
          repaintChangesOnly={true}
          highlightChanges={true}
          columnAutoWidth={true}
          wordWrapEnabled={true}
          style={{ maxHeight: "800px", marginBottom: "10px" }}
        >
          <SearchPanel
            visible={true}
            highlightCaseSensitive={true}
            width={240}
          />
          <Scrolling
            mode={"virtual"}
            rowRenderingMode={"virtual"}
            columnRenderingMode={"virtual"}
            showScrollbar={"always"}
          />
          <HeaderFilter visible={true} />
          {/* <FilterRow visible={true} applyFilter={"auto"} /> */}
          <Paging enabled={false} />
          <Sorting mode={"multiple"} />
          {/* <Selection mode={"single"} /> */}
          <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
            <Position
              my={"right top"}
              at={"right bottom"}
              of={".dx-datagrid-column-chooser-button"}
            />
          </ColumnChooser>
          <Editing
            // mode={"batch"}
            mode={"cell"}
            allowAdding={IRB.siteNo ? true : false}
            allowUpdating={IRB.siteNo ? true : false}
            allowDeleting={IRB.siteNo ? true : false}
            selectTextOnEditStart={true}
            startEditAction={"dblClick"}
            // newRowPosition={"last"}
          />

          {/* <DataGridToolbar>
            <DataGridItem name="addRowButton" location={"after"} />
            <DataGridItem name="columnChooserButton" />
            <DataGridItem name="searchPanel" />
          </DataGridToolbar> */}

          <Column
            dataField={"type"}
            caption={"Type"}
            dataType={"string"}
            showEditorAlways={true}
          >
            <Lookup
              dataSource={clinicalSiteStepType}
              displayExpr={"name"}
              valueExpr={"id"}
            />
          </Column>
          <Column
            dataField={"name"}
            caption={"Name"}
            dataType={"string"}
            showEditorAlways={true}
          ></Column>
          <Column
            dataField={"employeeNo"}
            caption={"Employee No."}
            dataType={"string"}
            visible={false}
          ></Column>
          <Column
            dataField={"assignedDate"}
            caption={"Assigned Date"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={200}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
          <Column
            dataField={"unassignedDate"}
            caption={"Unassigned Date"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={200}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-dd",
            }}
            showEditorAlways={true}
          />
        </DataGrid>
        <Toolbar>
          <Item
            location={"before"}
            widget={"dxButton"}
            options={prevItemOptions}
          />
          <Item
            location={"after"}
            widget={"dxButton"}
            options={nextItemOptions}
          />
        </Toolbar>
      </div>
    </IRBClinicalSiteFormWrapper>
  );
}
